var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"va-sidebar",class:_vm.computedClass,style:(_vm.computedStyle)},[_c('ul',{staticClass:"va-sidebar__menu"},[_vm._t("menu")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }